<template>
  <div>


    <el-container>
      <!-- 顶部 -->
      <el-header>
        <div>
          <div class="bamtopclass">领导后台管理</div>
          <div class="removeLogin">
            <el-button type="primary" @click="outlogin"> 退出登录</el-button>
          </div>
          <div><span class="username">{{ username }}</span></div>
        </div>

      </el-header>
      <el-container class="home_class">
        <el-aside width="200px">
          <!-- 左侧 -->
          <el-menu router>
            <!-- 一级菜单 -->
            <el-submenu index="1">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-xinwen"></span>
                <span>新闻管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="leadergetnews">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinwenliebiao-02"></span>
                    <span @click="newscli">新闻列表</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>

            </el-submenu>
            <el-submenu index="4">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-daohanglan"></span>
                <span>信息申报</span>
              </template>
              <!-- 二级菜单 -->
              <!-- <el-menu-item-group> -->
                <el-menu-item index="ViewStudentIelts">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>雅思成绩记录</span>
                  </template>
                </el-menu-item>
              <!-- </el-menu-item-group>
              <el-menu-item-group> -->
                <el-menu-item index="LeaderIeltsText">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>雅思模拟成绩记录</span>
                  </template>
                </el-menu-item>
              <!-- </el-menu-item-group> -->
              <!-- 二级菜单 -->
              <!-- <el-menu-item-group> -->
                <el-menu-item index="ViewTeacherWork">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>老师工作汇报</span>
                  </template>
                </el-menu-item>
              <!-- </el-menu-item-group>
              <el-menu-item-group> -->
                <el-menu-item index="ViewTeacherLectures">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>老师听课记录</span>
                  </template>
                </el-menu-item>
              <!-- </el-menu-item-group> -->

            </el-submenu>

            <!-- 一级菜单 -->
            <el-submenu index="11">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-xinwen"></span>
                <span>公告管理</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="ViewAccessory">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinwenliebiao-02"></span>
                    <span>公告查询</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>

            </el-submenu>
            <el-submenu index="66">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-huibao"></span>
                <span>听课记录</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="asLectures">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>填写听课记录</span>
                  </template>
                </el-menu-item>
              <el-menu-item index="LeaderSupervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >填写学风督查</span>
        </template>
          </el-menu-item>

           
              <!-- 二级菜单 -->
           
                <el-menu-item index="asViewTeahcherLectures">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-wentihuibao"></span>
                    <span>查看听课记录</span>
                  </template>
                </el-menu-item>
         
          <el-menu-item index="LeaderViewSupervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span>查看学风督查</span>
        </template>
          </el-menu-item>


              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="41">
              <!-- 一级菜单模块区域 -->
              <template slot="title">
                <!-- 图标 -->
                <span class="iconfont icon-daohanglan"></span>
                <span>工作汇报</span>
              </template>


              <!-- 二级菜单 -->
              <el-menu-item-group>
                <el-menu-item index="asteacherPeport">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>工作汇报</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>

              <!-- <el-menu-item-group>
                <el-menu-item index="leaderKpi">
                  <template slot="title">
                    <span class="iconfont icon-xinzeng"></span>
                    <span>KPI填写</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              
              <el-menu-item-group>
                <el-menu-item index="ViewKpi">
                  <template slot="title">
                    <span class="iconfont icon-xinzeng"></span>
                    <span>KPI查看</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group> -->
              <el-menu-item index="viewPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>老师绩效查看</span>
                  </template>
                </el-menu-item>
                
                <el-menu-item index="viewLPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>辅导员绩效查看</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="viewAPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>行政人员绩效查看</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="viewPPerformance">
                  <template slot="title">
                    <!-- 图标 -->
                    <span class="iconfont icon-xinzeng"></span>
                    <span>专业老师人员绩效查看</span>
                  </template>
                </el-menu-item>
            </el-submenu>
            <el-submenu index="44">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>文件管理</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group>
          <el-menu-item index="LeaderCloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>文件上传</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="LeaderPublicCloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>公用文件</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="20">
        <template slot="title">
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>调查问卷</span>
        </template>
              <el-menu-item-group>
          <el-menu-item index="leaderQuestionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="leaderViewQuestionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷查看</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>

        <el-menu-item-group>
          <el-menu-item index="ealderAnswerQuestion">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷填写</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
      </el-submenu>
          </el-menu>

        </el-aside>

        <el-container>
          <el-main>

            <router-view></router-view>

          </el-main>
          <el-footer>Footer</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  created() {
    this.newscli()
  },
  methods: {
    newscli() {
      this.username = JSON.parse(localStorage.getItem('user')).username
    },
    outlogin() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.$router.push({
        name: 'Login',
      })
    }
  }, data() {
    return {
      username: ''
    }
  }

}
</script>

<style scoped>
.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
  min-width: 1400px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;

  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: left;
  min-width: 1200px;
}

.home_class {
  height: 800px;
}

.removeLogin {
  float: right;
}

.bamtopclass {
  float: left;
  padding-left: 45%;
}

/* .el-submenu__title{
  margin-left: -80px;
 } */
.username {
  padding-left: 38%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/leader/leaderBam.vue